import { SVGProps, Ref, forwardRef } from 'react';

export const PauseFilledSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                d="M4.999 13.997c1.75 0 2-.25 2-2V4c0-1.75-.25-2-2-2s-2 .25-2 2v7.998c0 1.75.25 2 2 2"
                fill="currentColor"
            />
            <path
                d="M10.997 13.997c1.75 0 2-.25 2-2V4c0-1.75-.25-2-2-2s-2 .25-2 2v7.998c0 1.75.25 2 2 2"
                fill="currentColor"
            />
        </g>
    </svg>
));
PauseFilledSize16Glyph.displayName = 'PauseFilledSize16Glyph';
